import { styled } from '@mui/material/styles';
import { Grid } from '@mui/system';

const StyledGridContainerSubtitle = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(3),
  fontWeight: 'bold',
  fontSize: '1.125rem',
  letterSpacing: '-0.5px',
  lineHeight: '1.5rem',
  fontFamily: theme.typography.mainFont,
}));

export { StyledGridContainerSubtitle };
